import React from 'react';
import ReactDOM from 'react-dom';
import { useTutorial } from '../context/TutorialContext';
import { useTutorialPosition } from '../hooks/useTutorialPosition';
import './TutorialTooltip.css';

const TutorialTooltip = () => {
  const { isActive, getCurrentStep, isStepVisibleOnRoute, advanceStep, currentStepIndex, totalSteps } =
    useTutorial();

  const step = getCurrentStep();
  const position = useTutorialPosition(step?.targetSelector, step);

  if (!isActive || !isStepVisibleOnRoute() || !position || !step) return null;

  const { top, left, placement, arrowLeft } = position;

  return ReactDOM.createPortal(
    <div
      className={`tutorial-tooltip tutorial-tooltip--${placement}`}
      style={{ top, left }}
      role="dialog"
      aria-modal="false"
      aria-label="Tutorial tip"
    >
      {/* Arrow */}
      <div
        className="tutorial-tooltip__arrow"
        style={{ left: arrowLeft }}
      />

      {/* Step counter */}
      <p className="tutorial-tooltip__counter">
        {currentStepIndex + 1} / {totalSteps}
      </p>

      {/* Message */}
      <p className="tutorial-tooltip__message">{step.message}</p>

      {/* Button (only for 'button' advance steps) */}
      {step.buttonText && (
        <button className="tutorial-tooltip__button" onClick={advanceStep}>
          {step.buttonText}
        </button>
      )}

      {/* Hint for natural-click steps */}
      {!step.buttonText && (
        <p className="tutorial-tooltip__hint">Click to continue</p>
      )}
    </div>,
    document.body
  );
};

export default TutorialTooltip;
